import { classNames } from "../../utils"
import { Flex, type FlexProps } from "../Flex/Flex"

export type FlexEndProps = FlexProps

export function FlexEnd({ className, ...rest }: FlexEndProps) {
  return <Flex className={classNames("justify-end", className)} {...rest} />
}
